import { isNud } from '@/shared/utilities/typing'
import AccountUser from '@/shared/models/entities/account-user';
import PlannedWorksheet from "@/shared/models/entities/repocraft/planned-worksheet";
import StudentWorksheet from '@/shared/models/entities/repocraft/student-worksheet';

/**
 * 実施児童ふり返りシート（nullable） エンティティ
 */
class AccountUserWorksheet {
    account_user;
    planned_worksheet;
    student_worksheet;
    comments;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.account_user = new AccountUser(properties.account_user);
        this.planned_worksheet = new PlannedWorksheet(properties.planned_worksheet);
        this.student_worksheet = new StudentWorksheet(properties.student_worksheet);

        this.comments = [];
        if ('comments' in properties) {
            for (let comment of properties.comments) {
                this.comments.push(new Comment(comment));
            }
        }
    }
}

export default AccountUserWorksheet;
